(function(){
  document.documentElement.classList.remove('no-js');
  var psUA=navigator.userAgent||'';
  var psIsIOS=/iPad|iPhone|iPod/.test(psUA);
  var psIsChromium=!psIsIOS && /Chrome|Chromium|Edg\//.test(psUA) && !/OPR\//.test(psUA);
  document.documentElement.classList.add(psIsChromium?'ps-refraction-supported':'ps-refraction-fallback');

  var PS_FLOATING_CART_KEY='psMainCartShortcut';

  function setFloatingCartSession(active){
    try{
      if(active) sessionStorage.setItem(PS_FLOATING_CART_KEY,'1');
      else sessionStorage.removeItem(PS_FLOATING_CART_KEY);
    }catch(e){}
  }

  function hasFloatingCartSession(){
    try{ return sessionStorage.getItem(PS_FLOATING_CART_KEY)==='1'; }catch(e){ return false; }
  }

  function floatingCartCount(){
    var countEl=document.querySelector('[data-floating-cart-count]');
    var raw=countEl ? parseInt(countEl.textContent||'0',10) : 0;
    return Number.isFinite(raw) ? raw : 0;
  }

  function updateFloatingCartVisibility(){
    var floating=document.querySelector('[data-floating-cart]');
    if(!floating) return;
    if(floating.dataset.active!=='1' && hasFloatingCartSession()) floating.dataset.active='1';
    var active=floating.dataset.active==='1';
    var sticky=document.querySelector('[data-sticky-buy]');
    var stickyVisible=!!(sticky && sticky.classList.contains('is-visible'));
    var compact=document.querySelector('[data-ps-scroll-header]');
    var compactVisible=!!(compact && compact.classList.contains('is-visible'));
    var nearTop=window.scrollY < 110;
    var hasItems=floatingCartCount() > 0;
    /* The floating shortcut is only a fallback when neither visible header nor sticky buy exposes a cart. */
    var shouldShow=active && hasItems && !stickyVisible && !compactVisible && !nearTop;
    floating.hidden=!hasItems;
    floating.classList.toggle('is-visible',shouldShow);
  }

  var PS_CART_COUNT_KEY='psCartCount';

  function setCartCountEverywhere(count){
    var value=Math.max(0,parseInt(count,10)||0);
    document.querySelectorAll('[data-cart-count],[data-sticky-cart-count],[data-floating-cart-count]').forEach(function(el){
      el.textContent=value;
    });
    document.querySelectorAll('.ps-cart-link,.ps-sticky-cart-link,.ps-floating-cart').forEach(function(el){
      el.setAttribute('aria-label','Cart with '+value+' item'+(value===1?'':'s'));
    });
    try{ sessionStorage.setItem(PS_CART_COUNT_KEY,String(value)); }catch(e){}
    updateFloatingCartVisibility();
  }

  function restoreSessionCartCount(){
    try{
      var saved=sessionStorage.getItem(PS_CART_COUNT_KEY);
      if(saved!==null) setCartCountEverywhere(saved);
    }catch(e){}
  }

  function syncCartCountFromServer(){
    if(!window.fetch) return;
    fetch('/cart.js',{cache:'no-store',headers:{Accept:'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('cart sync'); return r.json(); })
      .then(function(cart){ setCartCountEverywhere(cart.item_count); })
      .catch(function(){});
  }

  function showToast(message){
    var toast=document.getElementById('PocketSaberToast');
    if(!toast)return;
    toast.textContent=message;
    toast.classList.add('is-showing');
    clearTimeout(toast._timer);
    toast._timer=setTimeout(function(){toast.classList.remove('is-showing');},2600);
  }

  function setVariant(form,source){
    if(!source) return;
    var data=source.dataset || {};
    var id=data.variantId || source.value;
    var pdp=source.closest('[data-pdp]') || document;
    var matchingButton=pdp.querySelector('[data-product-variant][data-variant-id="'+String(id)+'"]');
    var sourceData=matchingButton ? matchingButton.dataset : data;
    var price=sourceData.variantPrice || data.variantPrice;
    var comparePrice=sourceData.comparePrice || data.comparePrice;
    var description=sourceData.variantDescription || data.variantDescription;
    var whatGet=sourceData.variantWhatGet || data.variantWhatGet;
    var available=String(sourceData.variantAvailable || data.variantAvailable)!=='false';
    var packLabel=(sourceData.packLabel || data.packLabel || source.textContent || 'POCKETSABER').trim();

    pdp.querySelectorAll('[data-product-variant]').forEach(function(b){
      var active=b.dataset.variantId===String(id);
      b.classList.toggle('is-selected',active);
      b.setAttribute('aria-pressed',active?'true':'false');
    });
    pdp.querySelectorAll('form[data-product-form] input[name="id"], form.ps-product-form input[name="id"]').forEach(function(input){ input.value=id; });
    pdp.querySelectorAll('[data-product-price]').forEach(function(priceEl){ if(price) priceEl.textContent=price; });
    pdp.querySelectorAll('[data-current-compare-price]').forEach(function(el){ if(comparePrice) el.textContent=comparePrice; });
    pdp.querySelectorAll('[data-sticky-pack-label]').forEach(function(el){ el.textContent=packLabel; });
    pdp.querySelectorAll('[data-pdp-lead]').forEach(function(el){ if(description) el.textContent=description; });
    pdp.querySelectorAll('[data-pdp-what-get]').forEach(function(el){ if(whatGet) el.textContent=whatGet; });
    pdp.querySelectorAll('.ps-pdp__add,.ps-sticky-buy__button').forEach(function(submit){
      submit.disabled=!available;
      submit.textContent=available?'ADD TO CART':'SOLD OUT';
    });
    pdp.querySelectorAll('[data-sticky-variant-select]').forEach(function(select){
      if(String(select.value)!==String(id)) select.value=String(id);
    });
  }

  function initProductForms(root){
    (root||document).querySelectorAll('form.ps-buy-form, form.ps-product-form, form[data-product-form]').forEach(function(form){
      if(form.dataset.psInitForm) return;
      form.dataset.psInitForm='true';
      form.querySelectorAll('[data-product-variant]').forEach(function(button){
        button.addEventListener('click',function(){ if(!button.disabled) setVariant(form,button); });
      });
      form.querySelectorAll('[data-sticky-variant-select]').forEach(function(select){
        select.addEventListener('change',function(){
          var opt=select.options[select.selectedIndex];
          if(opt) setVariant(form,opt);
        });
      });
      form.addEventListener('submit',async function(e){
        var submitter=e.submitter;
        if(submitter && !submitter.matches('.ps-pdp__add,.ps-buy__cta,button[type="submit"]')) return;
        if(!window.fetch) return;
        e.preventDefault();
        var submit=form.querySelector('.ps-pdp__add, .ps-buy__cta, button[type="submit"]');
        var oldText=submit?submit.textContent:'';
        if(submit){ submit.disabled=true; submit.textContent='ADDING...'; }
        try{
          var response=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
          if(!response.ok) throw new Error('Cart error');
          var cart=await fetch('/cart.js').then(function(r){ return r.json(); });
          setCartCountEverywhere(cart.item_count);
          document.querySelectorAll('.ps-cart-link,.ps-sticky-cart-link,.ps-floating-cart').forEach(function(el){
            el.classList.remove('is-cart-pulse');
            void el.offsetWidth;
            el.classList.add('is-cart-pulse');
          });
          if(submit){
            submit.classList.add('is-added');
            submit.textContent='ADDED TO CART!';
            if(submit.classList.contains('ps-pdp__add')){
              var floating=document.querySelector('[data-floating-cart]');
              if(floating){
                floating.hidden=false;
                floating.dataset.active='1';
                setFloatingCartSession(true);
                floating.classList.remove('is-cart-pulse');
                void floating.offsetWidth;
                floating.classList.add('is-cart-pulse');
              }
            }
            updateFloatingCartVisibility();
            setTimeout(function(){ submit.disabled=false; submit.classList.remove('is-added'); submit.textContent=oldText||'ADD TO CART'; },1500);
          }
        }catch(err){
          if(submit){ submit.disabled=false; submit.textContent=oldText||'ADD TO CART'; }
          HTMLFormElement.prototype.submit.call(form);
        }
      });
    });
  }

  function initCartPage(root){
    var doc=root||document;
    var form=doc.querySelector('[data-cart-form]') || document.querySelector('[data-cart-form]');
    if(!form || form.dataset.cartAjaxInit) return;
    form.dataset.cartAjaxInit='1';
    var currency=form.dataset.cartCurrency || 'USD';
    var pendingByKey={};
    var queuedByKey={};

    function money(cents){
      try{
        return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format((Number(cents)||0)/100);
      }catch(e){
        return '$'+((Number(cents)||0)/100).toFixed(2);
      }
    }

    function updateCounts(cart){
      setCartCountEverywhere(cart.item_count);
    }

    async function changeItem(itemEl,quantity,removeLink){
      if(!itemEl) return;
      var key=itemEl.dataset.cartKey;
      if(!key) return;
      quantity=Math.max(0,parseInt(quantity,10)||0);
      var qtyInput=itemEl.querySelector('[data-cart-quantity]');

      /* If the shopper keeps typing while Shopify is processing the previous value,
         remember only the newest requested quantity instead of stealing focus. */
      if(pendingByKey[key]){
        queuedByKey[key]={quantity:quantity,removeLink:removeLink||null};
        return;
      }

      var previous=qtyInput ? Math.max(1,parseInt(qtyInput.dataset.lastValue || qtyInput.value || '1',10)||1) : 1;
      var requested=quantity;
      pendingByKey[key]=true;
      itemEl.classList.add('is-cart-updating');

      try{
        var response=await fetch('/cart/change.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:key,quantity:quantity})
        });
        if(!response.ok) throw new Error('Cart update failed');
        var cart=await response.json();
        updateCounts(cart);
        var subtotal=document.querySelector('[data-cart-subtotal]');
        if(subtotal) subtotal.textContent=money(cart.total_price);

        if(quantity===0){
          if(cart.item_count===0){
            window.location.reload();
            return;
          }
          itemEl.remove();
          return;
        }

        var currentItem=(cart.items||[]).find(function(item){ return item.key===key; });
        if(currentItem){
          if(qtyInput){
            var rawNow=String(qtyInput.value||'').trim();
            var typedNow=rawNow==='' ? null : parseInt(rawNow,10);
            var activelyEditing=document.activeElement===qtyInput;
            var hasNewerTyping=activelyEditing && (rawNow==='' || !Number.isFinite(typedNow) || typedNow!==requested);
            qtyInput.dataset.lastValue=String(currentItem.quantity);
            /* Do not replace what is under the shopper's cursor if they have already
               begun typing the next value. This keeps the mobile keyboard open. */
            if(!hasNewerTyping) qtyInput.value=currentItem.quantity;
          }
          var linePrice=itemEl.querySelector('[data-cart-line-price]');
          if(linePrice) linePrice.textContent=money(currentItem.final_line_price);
        }else{
          window.location.reload();
        }
      }catch(err){
        if(qtyInput){
          var rawCurrent=String(qtyInput.value||'').trim();
          var typedCurrent=rawCurrent==='' ? null : parseInt(rawCurrent,10);
          var hasNewerEdit=document.activeElement===qtyInput && (rawCurrent==='' || typedCurrent!==requested);
          if(!hasNewerEdit){
            qtyInput.value=previous;
            qtyInput.dataset.lastValue=String(previous);
          }
        }
        if(removeLink && removeLink.href){
          window.location.href=removeLink.href;
          return;
        }
        showToast('Could not update cart. Please try again.');
      }finally{
        delete pendingByKey[key];
        if(document.documentElement.contains(itemEl)) itemEl.classList.remove('is-cart-updating');
        var queued=queuedByKey[key];
        delete queuedByKey[key];
        if(queued && document.documentElement.contains(itemEl)){
          var latest=Math.max(1,parseInt(qtyInput && qtyInput.dataset.lastValue || '1',10)||1);
          if(queued.quantity===0 || queued.quantity!==latest){
            changeItem(itemEl,queued.quantity,queued.removeLink);
          }
        }
      }
    }

    form.querySelectorAll('[data-cart-remove]').forEach(function(link){
      link.addEventListener('click',function(e){
        if(!window.fetch) return;
        e.preventDefault();
        changeItem(link.closest('[data-cart-item]'),0,link);
      });
    });

    form.querySelectorAll('[data-cart-quantity]').forEach(function(input){
      var timer=null;

      function parsedValue(){
        var raw=String(input.value||'').trim();
        if(raw==='') return null;
        var value=parseInt(raw,10);
        if(!Number.isFinite(value) || value<1) return null;
        return value;
      }

      function restoreLast(){
        var current=Math.max(1,parseInt(input.dataset.lastValue||'1',10)||1);
        input.value=String(current);
      }

      function commit(){
        clearTimeout(timer);
        var next=parsedValue();
        if(next===null){
          /* An empty field is allowed while the shopper is replacing a number. */
          if(document.activeElement!==input) restoreLast();
          return;
        }
        var current=Math.max(1,parseInt(input.dataset.lastValue||'1',10)||1);
        if(next===current) return;
        changeItem(input.closest('[data-cart-item]'),next,null);
      }

      function queue(){
        clearTimeout(timer);
        if(parsedValue()===null) return;
        /* Enough time to type multi-digit quantities, but still feels live. */
        timer=setTimeout(commit,520);
      }

      input.addEventListener('input',queue);
      input.addEventListener('change',commit);
      input.addEventListener('blur',function(){
        if(String(input.value||'').trim()==='') restoreLast();
        else commit();
      });
      input.addEventListener('keydown',function(e){
        if(e.key==='Enter'){
          e.preventDefault();
          commit();
          /* Intentionally keep focus so the mobile numeric keyboard stays open. */
        }
      });
    });
  }

  function initSaleCountdown(){
    document.querySelectorAll('[data-sale-countdown]').forEach(function(el){
      if(el.dataset.countdownInit) return;
      el.dataset.countdownInit='1';
      function tick(){
        var now=new Date();
        var end=new Date(now);
        end.setMinutes(60,0,0);
        var diff=Math.max(0,end.getTime()-now.getTime());
        var h=Math.floor(diff/3600000), m=Math.floor((diff%3600000)/60000), s=Math.floor((diff%60000)/1000);
        el.textContent=String(h).padStart(2,'0')+':'+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0');
      }
      tick(); setInterval(tick,1000);
    });
  }

  function initPdpGallery(root){
    (root||document).querySelectorAll('[data-pdp-gallery]').forEach(function(gallery){
      if(gallery.dataset.galleryInit) return;
      gallery.dataset.galleryInit='1';
      var wrap=gallery.closest('.ps-pdp__media-wrap');
      var counter=wrap?wrap.querySelector('[data-gallery-current]'):null;
      var items=Array.prototype.slice.call(gallery.querySelectorAll('.ps-pdp-media'));
      var thumbs=wrap?Array.prototype.slice.call(wrap.querySelectorAll('[data-gallery-thumb]')):[];
      var index=0;
      var programmaticScroll=false;
      var programmaticTimer=null;
      function goTo(next,behavior,centerThumb){
        index=Math.max(0,Math.min(items.length-1,next));
        var item=items[index];
        var scrollBehavior=behavior||'smooth';
        if(scrollBehavior==='smooth'){
          programmaticScroll=true;
          clearTimeout(programmaticTimer);
          programmaticTimer=setTimeout(function(){ programmaticScroll=false; },520);
        }else{
          programmaticScroll=false;
          clearTimeout(programmaticTimer);
        }
        if(item){
          gallery.scrollTo({left:item.offsetLeft,behavior:scrollBehavior});
        }
        if(counter) counter.textContent=String(index+1);
        thumbs.forEach(function(btn,i){ btn.classList.toggle('is-active',i===index); btn.setAttribute('aria-pressed',i===index?'true':'false'); });
        if(centerThumb && thumbs[index] && wrap){
          var strip=wrap.querySelector('.ps-pdp__thumbs');
          if(strip && strip.scrollWidth>strip.clientWidth){
            var target=thumbs[index];
            var left=Math.max(0,target.offsetLeft-(strip.clientWidth-target.offsetWidth)/2);
            strip.scrollTo({left:left,behavior:behavior==='smooth'?'smooth':'auto'});
          }
        }
      }
      /* Lightbox can return the miniature gallery to the exact expanded image on close. */
      gallery._psGoTo=goTo;
      gallery._psGetIndex=function(){ return index; };
      thumbs.forEach(function(btn){
        btn.addEventListener('click',function(){ goTo(parseInt(btn.dataset.galleryThumb,10)||0,'smooth'); });
      });
      var prev=wrap?wrap.querySelector('[data-gallery-prev]'):null;
      var next=wrap?wrap.querySelector('[data-gallery-next]'):null;
      if(prev) prev.addEventListener('click',function(){ goTo(index-1,'smooth'); });
      if(next) next.addEventListener('click',function(){ goTo(index+1,'smooth'); });

      var touchStartX=0, touchStartY=0, touchStartScroll=0, touchStartIndex=0, touchHorizontal=false, touchMoved=false;
      gallery.addEventListener('touchstart',function(e){
        if(window.innerWidth>640 || !e.touches || !e.touches.length) return;
        var t=e.touches[0];
        touchStartX=t.clientX; touchStartY=t.clientY; touchStartScroll=gallery.scrollLeft; touchStartIndex=index;
        touchHorizontal=false; touchMoved=false;
      },{passive:true});
      gallery.addEventListener('touchmove',function(e){
        if(window.innerWidth>640 || !e.touches || !e.touches.length) return;
        var t=e.touches[0];
        var dx=t.clientX-touchStartX, dy=t.clientY-touchStartY;
        if(!touchMoved && (Math.abs(dx)>7 || Math.abs(dy)>7)){
          touchMoved=true; touchHorizontal=Math.abs(dx)>Math.abs(dy)*1.28;
        }
        if(touchHorizontal){
          e.preventDefault();
          gallery.scrollLeft=touchStartScroll-dx;
        }
      },{passive:false});
      gallery.addEventListener('touchend',function(e){
        if(window.innerWidth>640 || !touchHorizontal) return;
        var changed=e.changedTouches&&e.changedTouches[0];
        var dx=changed?changed.clientX-touchStartX:0;
        if(Math.abs(dx)>42) goTo(touchStartIndex+(dx<0?1:-1),'smooth');
        else {
          var nearest=Math.round(gallery.scrollLeft/Math.max(1,gallery.clientWidth));
          goTo(nearest,'smooth');
        }
        touchHorizontal=false; touchMoved=false;
      },{passive:true});

      gallery.addEventListener('scroll',function(){
        /* On mobile the gallery is driven by our touch-end snap logic. Updating the
           counter continuously while a finger is between two slides made 1/7 ↔ 2/7
           flicker around the halfway point. On desktop, ignore the intermediate
           frames of our own smooth scroll so the cyan thumbnail ring never jumps
           back to the previous image mid-transition. */
        if(window.innerWidth<=640 || programmaticScroll) return;
        var center=gallery.scrollLeft + gallery.clientWidth/2;
        var best=0, bestDist=Infinity;
        items.forEach(function(item,i){ var c=item.offsetLeft+item.offsetWidth/2; var d=Math.abs(c-center); if(d<bestDist){ bestDist=d; best=i; } });
        index=best;
        if(counter) counter.textContent=String(index+1);
        thumbs.forEach(function(btn,i){ btn.classList.toggle('is-active',i===index); });
      },{passive:true});
      if('onscrollend' in gallery){ gallery.addEventListener('scrollend',function(){ programmaticScroll=false; clearTimeout(programmaticTimer); },{passive:true}); }
      window.addEventListener('resize',function(){ goTo(index,'auto'); },{passive:true});
      goTo(0,'auto');
    });
  }

  function initVideoCarousels(root){
    (root||document).querySelectorAll('[data-video-carousel]').forEach(function(section){
      if(section.dataset.videoInit) return;
      section.dataset.videoInit='1';
      var track=section.querySelector('[data-video-track]');
      if(!track) return;
      var originals=Array.prototype.slice.call(track.querySelectorAll('.ps-video-card'));
      if(!originals.length) return;
      var visible=!('IntersectionObserver' in window);
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var offset=0;
      var last=performance.now();
      var originalWidth=0;
      var lastViewportWidth=window.innerWidth;
      var rafId=null;
      var lastPlaybackSync=0;
      /* Some iOS in-app browsers do not allow HTML5 video to stay inline.
         In that case, never start playback: keep the poster cards moving in the
         conveyor instead of letting the WebView promote a clip over the page. */
      var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform==='MacIntel' && navigator.maxTouchPoints>1);
      var inlinePlaybackSupported=!isiOS || !window.matchMedia || window.matchMedia('(-webkit-video-playable-inline)').matches;
      var posterFallback=!inlinePlaybackSupported;

      section.style.touchAction='pan-y';
      track.style.pointerEvents='none';

      /* In social WebViews that cannot safely keep video inline, use the poster
         images as real image elements instead of leaving eight paused <video>
         surfaces in the moving rail. This keeps the exact same visual fallback
         while letting the browser compositor move a much cheaper layer. */
      if(posterFallback){
        originals.forEach(function(card){
          var video=card.querySelector('video');
          if(!video) return;
          var poster=video.getAttribute('poster');
          if(!poster) return;
          var img=document.createElement('img');
          img.className=video.className+' ps-video-card__poster';
          img.src=poster;
          img.alt='';
          img.setAttribute('aria-hidden','true');
          img.setAttribute('draggable','false');
          img.decoding='async';
          img.loading='eager';
          try{ img.fetchPriority='low'; }catch(e){}
          video.replaceWith(img);
        });
        track.classList.add('ps-video-track--poster-loop');
      }

      function prepareVideo(video,playNow){
        if(!video) return;
        video.muted=true;
        video.defaultMuted=true;
        video.playsInline=true;
        video.setAttribute('playsinline','true');
        video.setAttribute('webkit-playsinline','true');
        video.setAttribute('x5-playsinline','true');
        video.setAttribute('disablepictureinpicture','');
        video.setAttribute('controlslist','nodownload noplaybackrate nofullscreen');
        if(!inlinePlaybackSupported){
          video.preload='none';
          try{ video.pause(); }catch(e){}
          return;
        }
        if(video.preload!=='auto') video.preload='auto';
        if(video.readyState===0){ try{ video.load(); }catch(e){} }
        if(playNow!==false){
          var playPromise=video.play();
          if(playPromise && typeof playPromise.catch==='function') playPromise.catch(function(){});
        }
      }

      function allCards(){ return Array.prototype.slice.call(track.querySelectorAll('.ps-video-card')); }
      function allVideos(){ return Array.prototype.slice.call(track.querySelectorAll('video')); }

      function buildLoop(preserveProgress){
        var progress=originalWidth>0 ? ((-offset)%originalWidth)/originalWidth : 0;
        Array.prototype.slice.call(track.querySelectorAll('[data-video-clone]')).forEach(function(clone){clone.remove();});
        track.style.transform='translate3d(0,0,0)';
        originalWidth=track.scrollWidth;
        var firstWidth=originals[0].getBoundingClientRect().width || 290;
        var gap=parseFloat(getComputedStyle(track).gap||'14')||14;
        var clonesNeeded=Math.min(originals.length,Math.ceil((section.clientWidth+firstWidth)/(firstWidth+gap))+2);
        for(var i=0;i<clonesNeeded;i++){
          var clone=originals[i%originals.length].cloneNode(true);
          clone.setAttribute('data-video-clone','true');
          track.appendChild(clone);
        }
        offset=preserveProgress && originalWidth>0 ? -(progress*originalWidth) : offset;
        if(!Number.isFinite(offset)) offset=0;
        track.style.transform='translate3d('+offset+'px,0,0)';
        if(posterFallback && originalWidth>0){
          track.style.setProperty('--ps-poster-loop-end',(-originalWidth)+'px');
          track.style.setProperty('--ps-poster-loop-duration',Math.max(12,originalWidth/speed())+'s');
        }
      }

      function syncPlayback(){
        if(!inlinePlaybackSupported || !visible || document.hidden){
          allVideos().forEach(function(video){ video.pause(); });
          return;
        }
        var viewportWidth=window.innerWidth || document.documentElement.clientWidth;
        var buffer=window.innerWidth<=640 ? 260 : 360;
        allCards().forEach(function(card){
          var video=card.querySelector('video');
          if(!video) return;
          var rect=card.getBoundingClientRect();
          var near=rect.right>-buffer && rect.left<viewportWidth+buffer;
          if(near) prepareVideo(video,true); else video.pause();
        });
      }

      function speed(){ return window.innerWidth<=640?78:90; }
      function frame(now){
        if(posterFallback){ rafId=null; return; }
        if(!visible || reduced || document.hidden){ rafId=null; return; }
        var dt=Math.min(50,now-last)/1000; last=now;
        if(originalWidth>0){
          offset-=speed()*dt;
          if(-offset>=originalWidth) offset+=originalWidth;
          track.style.transform='translate3d('+offset+'px,0,0)';
        }
        if(now-lastPlaybackSync>280){
          lastPlaybackSync=now;
          syncPlayback();
        }
        rafId=requestAnimationFrame(frame);
      }
      function startLoop(){
        if(!visible || reduced || document.hidden) return;
        if(posterFallback){
          track.style.animationPlayState='running';
          return;
        }
        if(rafId!==null) return;
        last=performance.now();
        rafId=requestAnimationFrame(frame);
      }
      function stopLoop(){
        if(posterFallback) track.style.animationPlayState='paused';
        if(rafId!==null){ cancelAnimationFrame(rafId); rafId=null; }
      }

      buildLoop(false);
      if(posterFallback) track.style.animationPlayState=visible && !reduced && !document.hidden ? 'running' : 'paused';

      /* Warm the first clips after the critical page load so a fast scroll does not land on a frozen card. */
      function warmPriorityClips(){
        originals.slice(0,3).forEach(function(card){ prepareVideo(card.querySelector('video'),false); });
      }
      if(document.readyState==='complete'){
        setTimeout(warmPriorityClips,450);
      }else{
        window.addEventListener('load',function(){ setTimeout(warmPriorityClips,450); },{once:true});
      }

      if(visible){ syncPlayback(); startLoop(); }
      if('IntersectionObserver' in window){
        var nearIo=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(!entry.isIntersecting) return;
            warmPriorityClips();
            /* Preload nearby clips, but do not start them until the actual video
               section is on-screen. This prevents embedded social browsers from
               promoting a background-started clip over the storefront. */
            originals.slice(0,3).forEach(function(card){ prepareVideo(card.querySelector('video'),false); });
          });
        },{threshold:0,rootMargin:'900px 0px 500px 0px'});
        nearIo.observe(section);

        var io=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            visible=entry.isIntersecting;
            last=performance.now();
            if(visible){ syncPlayback(); startLoop(); }
            else{ stopLoop(); allVideos().forEach(function(video){ video.pause(); }); }
          });
        },{threshold:.02,rootMargin:'80px 0px 80px 0px'});
        io.observe(section);
      }
      window.addEventListener('resize',function(){
        var width=window.innerWidth;
        if(Math.abs(width-lastViewportWidth)>24){
          lastViewportWidth=width;
          buildLoop(true);
          last=performance.now();
          syncPlayback();
        }
      },{passive:true});
      document.addEventListener('visibilitychange',function(){
        if(document.hidden){ stopLoop(); allVideos().forEach(function(video){ video.pause(); }); }
        else if(visible){ syncPlayback(); startLoop(); }
      });
      section.addEventListener('dragstart',function(e){e.preventDefault();});
      section.addEventListener('touchmove',function(e){
        if(e.touches && e.touches.length>1) e.preventDefault();
      },{passive:false});
    });
  }

  function initReviewSections(root){
    (root||document).querySelectorAll('[data-reviews-section]').forEach(function(section){
      if(section.dataset.reviewInit) return;
      section.dataset.reviewInit='true';

      var track=section.querySelector('[data-carousel-track]');
      var prev=section.querySelector('[data-carousel-prev]');
      var next=section.querySelector('[data-carousel-next]');
      function carouselMove(dir){
        if(!track) return;
        track.scrollBy({left:dir*Math.max(320,track.clientWidth*.98),behavior:'smooth'});
      }
      if(prev) prev.addEventListener('click',function(){carouselMove(-1);});
      if(next) next.addEventListener('click',function(){carouselMove(1);});

      /* Keep the featured photo reviews natively swipeable on touch, and add a
         lightweight click-drag gesture on desktop so shoppers can move through
         them without hunting for the arrow buttons. */
      if(track && !track.dataset.dragInit){
        track.dataset.dragInit='1';
        var dragging=false,dragStartX=0,dragStartScroll=0,dragMoved=false;
        track.addEventListener('pointerdown',function(e){
          if(e.pointerType!=='mouse' || e.button!==0) return;
          dragging=true; dragMoved=false; dragStartX=e.clientX; dragStartScroll=track.scrollLeft;
          track.classList.add('is-dragging');
          try{ track.setPointerCapture(e.pointerId); }catch(err){}
        });
        track.addEventListener('pointermove',function(e){
          if(!dragging) return;
          var dx=e.clientX-dragStartX;
          if(Math.abs(dx)>4) dragMoved=true;
          if(dragMoved){ e.preventDefault(); track.scrollLeft=dragStartScroll-dx; }
        });
        function finishDrag(e){
          if(!dragging) return;
          dragging=false; track.classList.remove('is-dragging');
          try{ track.releasePointerCapture(e.pointerId); }catch(err){}
        }
        track.addEventListener('pointerup',finishDrag);
        track.addEventListener('pointercancel',finishDrag);
        track.addEventListener('click',function(e){ if(dragMoved){ e.preventDefault(); e.stopPropagation(); dragMoved=false; } },true);
      }

      var items=Array.prototype.slice.call(section.querySelectorAll('[data-review-item]'));
      var reviewList=section.querySelector('[data-review-list]');
      var filterButtons=Array.prototype.slice.call(section.querySelectorAll('[data-review-filter]'));
      var sortSelect=section.querySelector('[data-review-sort]');
      var pagesWrap=section.querySelector('[data-review-pages]');
      var current='all';
      var currentSort=sortSelect ? sortSelect.value : 'relevant';
      var currentPage=1;
      var perPage=5;
      items.forEach(function(item,i){ item.dataset.originalIndex=String(i); });

      /* Curated relevance keeps photo-backed reviews mixed with the strongest
         descriptive reviews instead of simply putting every photo first. */
      var relevantOrder=[
        'wurx','CleverGirl','Zehvanarelynn','imalexmoss','m**o','d**s','its Adela',
        '🌻 Krista 🌻','nvm','Clare','hawa 🦋💞','dj95552','Mrcorky','Hannah Gearhart',
        '🇺🇸 security 24/7🇺🇸','Kenner Beltran'
      ];
      var relevantMap={};
      relevantOrder.forEach(function(name,i){ relevantMap[name]=1000-i; });
      function reviewName(item){ var el=item.querySelector('.ps-review-card__identity strong'); return el?el.textContent.trim():''; }
      function reviewDate(item){
        var meta=item.querySelectorAll('.ps-review-card__meta span');
        var raw=meta.length ? meta[meta.length-1].textContent.trim() : '';
        var stamp=Date.parse(raw+'T00:00:00Z');
        return Number.isFinite(stamp)?stamp:0;
      }
      function relevantScore(item){
        var name=reviewName(item);
        if(Object.prototype.hasOwnProperty.call(relevantMap,name)) return relevantMap[name];
        var score=Number(item.dataset.rating||0)*10;
        if(item.dataset.photo==='true') score+=32;
        var p=item.querySelector('.ps-review-card__content > p');
        var text=p?p.textContent.trim():'';
        if(text && !p.classList.contains('ps-review-card__rating-only')) score+=Math.min(28,text.length/7);
        score+=reviewDate(item)/1e13;
        return score;
      }
      function sortReviews(list){
        return list.slice().sort(function(a,b){
          if(currentSort==='recent'){
            return reviewDate(b)-reviewDate(a) || Number(a.dataset.originalIndex)-Number(b.dataset.originalIndex);
          }
          if(currentSort==='high'){
            return Number(b.dataset.rating)-Number(a.dataset.rating) || reviewDate(b)-reviewDate(a) || Number(a.dataset.originalIndex)-Number(b.dataset.originalIndex);
          }
          return relevantScore(b)-relevantScore(a) || reviewDate(b)-reviewDate(a) || Number(a.dataset.originalIndex)-Number(b.dataset.originalIndex);
        });
      }

      function matches(item,filter){
        if(filter==='all') return true;
        if(filter==='photos') return item.dataset.photo==='true';
        return item.dataset.rating===filter;
      }
      function renderPages(totalPages){
        if(!pagesWrap) return;
        pagesWrap.innerHTML='';
        if(totalPages<=1) return;
        function add(label,page,extra,disabled,active){
          var b=document.createElement('button');
          b.type='button';
          b.textContent=label;
          b.className='ps-page-btn'+(extra?' '+extra:'')+(active?' is-active':'');
          if(disabled) b.disabled=true;
          b.addEventListener('click',function(){
            currentPage=page;
            render();
            requestAnimationFrame(function(){
              var anchor=section.querySelector('.ps-review-controls') || section.querySelector('#all-reviews') || section;
              var header=document.querySelector('[data-ps-header]');
              var offset=(header ? header.getBoundingClientRect().height : 64) + 8;
              var top=Math.max(0,anchor.getBoundingClientRect().top + window.scrollY - offset);
              window.scrollTo({top:top,behavior:'auto'});
            });
          });
          pagesWrap.appendChild(b);
        }
        function addEllipsis(from,to){
          var jump=Math.max(1,Math.min(totalPages,Math.round((from+to)/2)));
          add('…',jump,'ps-page-btn--ellipsis',false,false);
        }
        add('‹',Math.max(1,currentPage-1),'ps-page-btn--nav',currentPage===1,false);
        if(totalPages<=5){
          for(var p=1;p<=totalPages;p++) add(String(p),p,'',false,p===currentPage);
        }else{
          add('1',1,'',false,currentPage===1);
          var start=Math.max(2,currentPage-1);
          var finish=Math.min(totalPages-1,currentPage+1);
          if(currentPage<=2){ start=2; finish=3; }
          if(currentPage>=totalPages-1){ start=totalPages-2; finish=totalPages-1; }
          if(start>2) addEllipsis(2,start-1);
          for(var p2=start;p2<=finish;p2++) add(String(p2),p2,'',false,p2===currentPage);
          if(finish<totalPages-1) addEllipsis(finish+1,totalPages-1);
          add(String(totalPages),totalPages,'',false,currentPage===totalPages);
        }
        add('›',Math.min(totalPages,currentPage+1),'ps-page-btn--nav',currentPage===totalPages,false);
      }
      function render(){
        var matched=sortReviews(items.filter(function(item){ return matches(item,current); }));
        if(reviewList){ matched.forEach(function(item){ reviewList.appendChild(item); }); }
        var totalPages=Math.max(1,Math.ceil(matched.length/perPage));
        if(currentPage>totalPages) currentPage=totalPages;
        var start=(currentPage-1)*perPage;
        var end=start+perPage;
        items.forEach(function(item){ item.classList.add('is-filter-hidden'); item.classList.remove('is-review-hidden'); });
        matched.forEach(function(item,index){ item.classList.toggle('is-filter-hidden',!(index>=start && index<end)); });
        filterButtons.forEach(function(button){
          var active=button.dataset.reviewFilter===current;
          button.classList.toggle('is-active',active);
          button.setAttribute('aria-pressed',active?'true':'false');
        });
        renderPages(totalPages);
      }
      filterButtons.forEach(function(button){
        button.addEventListener('click',function(){
          current=button.dataset.reviewFilter||'all';
          currentPage=1;
          render();
          if(button.closest('.ps-rating-panel')){ var anchor=section.querySelector('.ps-review-controls') || section; var header=document.querySelector('[data-ps-header]'); var offset=(header ? header.getBoundingClientRect().height : 64) + 8; var top=Math.max(0,anchor.getBoundingClientRect().top + window.scrollY - offset); window.scrollTo({top:top,behavior:'smooth'}); }
        });
      });
      if(sortSelect){
        sortSelect.addEventListener('change',function(){ currentSort=sortSelect.value||'relevant'; currentPage=1; render(); });
      }
      render();
    });
  }

  function initReveal(root){
    var targets=Array.prototype.slice.call((root||document).querySelectorAll('.ps-section:not(.ps-fan-videos):not(.ps-reviews--pdp),.ps-stat-strip,.ps-home-proof'));
    targets.forEach(function(el){ if(el.dataset.revealInit) return; el.dataset.revealInit='1'; el.classList.add('ps-reveal'); });
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)){
      targets.forEach(function(el){ el.classList.add('is-visible'); }); return;
    }
    var early=[];
    var normal=targets;
    var normalIo=new IntersectionObserver(function(entries){ entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.classList.add('is-visible'); normalIo.unobserve(entry.target); } }); },{threshold:.07,rootMargin:'0px 0px 4% 0px'});
    var earlyIo=new IntersectionObserver(function(entries){ entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.classList.add('is-visible'); earlyIo.unobserve(entry.target); } }); },{threshold:.01,rootMargin:'0px 0px 24% 0px'});
    normal.forEach(function(el){ normalIo.observe(el); });
    early.forEach(function(el){ earlyIo.observe(el); });
  }

  function initAccordions(root){
    (root||document).querySelectorAll('[data-accordion] details, .ps-pdp__details').forEach(function(detail){
      if(detail.dataset.accInit) return;
      detail.dataset.accInit='1';
      var summary=detail.querySelector('summary');
      if(!summary) return;
      summary.addEventListener('click',function(e){
        if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        e.preventDefault();
        if(detail._anim) detail._anim.cancel();
        var opening=!detail.open;
        var start=detail.getBoundingClientRect().height;
        if(opening) detail.open=true;
        var end=opening?detail.scrollHeight:summary.getBoundingClientRect().height;
        detail.style.overflow='hidden';
        detail._anim=detail.animate([{height:start+'px',opacity:.94},{height:end+'px',opacity:1}],{duration:360,easing:'cubic-bezier(.22,.72,.22,1)'});
        detail._anim.onfinish=function(){
          if(!opening) detail.open=false;
          detail.style.height=''; detail.style.overflow=''; detail._anim=null;
        };
        detail._anim.oncancel=function(){ detail.style.height=''; detail.style.overflow=''; detail._anim=null; };
      });
    });
  }

  function initLightbox(root){
    var doc=root||document;
    var overlay=document.getElementById('psLightbox');
    if(!overlay){
      overlay=document.createElement('div');
      overlay.id='psLightbox';
      overlay.className='ps-lightbox';
      overlay.innerHTML='<button type="button" class="ps-lightbox__zoom" aria-label="Zoom image"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M16 16l5 5M8.5 11h5M11 8.5v5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><button type="button" class="ps-lightbox__close" aria-label="Close image"><span aria-hidden="true">×</span></button><button type="button" class="ps-lightbox__nav ps-lightbox__prev" aria-label="Previous image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4l-8 8 8 8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button><button type="button" class="ps-lightbox__nav ps-lightbox__next" aria-label="Next image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4l8 8-8 8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button><div class="ps-lightbox__viewport"><img class="ps-lightbox__image" alt="Expanded media"></div>';
      document.body.appendChild(overlay);
      var image=overlay.querySelector('.ps-lightbox__image');
      var viewport=overlay.querySelector('.ps-lightbox__viewport');
      var zoomButton=overlay.querySelector('.ps-lightbox__zoom');
      var closeButton=overlay.querySelector('.ps-lightbox__close');
      var prevButton=overlay.querySelector('.ps-lightbox__prev');
      var nextButton=overlay.querySelector('.ps-lightbox__next');
      overlay._psGroup=[];
      overlay._psIndex=0;

      function positionControls(){
        if(!overlay.classList.contains('is-open') || !image) return;
        requestAnimationFrame(function(){
          var rect=image.getBoundingClientRect();
          if(!rect.width || !rect.height) return;
          var inset=window.innerWidth<=640?10:12;
          /* Keep utility controls anchored to the viewer's top-right, even while the image is zoomed/panned. */
          var top=window.innerWidth<=640?12:18;
          var closeRight=window.innerWidth<=640?12:18;
          var size=window.innerWidth<=640?40:42;
          if(closeButton){
            closeButton.style.setProperty('top',top+'px','important');
            closeButton.style.setProperty('right',closeRight+'px','important');
          }
          if(zoomButton){
            zoomButton.style.setProperty('top',top+'px','important');
            zoomButton.style.setProperty('right',(closeRight+size+8)+'px','important');
          }
          var navSize=window.innerWidth<=640?44:48;
          /* Keep the gallery arrows on one stable viewer rail so differently sized images
             cannot make them jump when the first next/previous control is tapped. */
          var stagePad=window.innerWidth<=640?32:48;
          var stageWidth=Math.min(Math.max(0,window.innerWidth-stagePad),960);
          var stageInset=Math.max(inset,(window.innerWidth-stageWidth)/2+inset);
          var navTop=Math.max(inset,Math.round((window.innerHeight-navSize)/2));
          if(prevButton){
            prevButton.style.setProperty('top',navTop+'px','important');
            prevButton.style.setProperty('left',stageInset+'px','important');
          }
          if(nextButton){
            nextButton.style.setProperty('top',navTop+'px','important');
            nextButton.style.setProperty('right',stageInset+'px','important');
          }
        });
      }
      function closeLightbox(){
        var sourceGallery=overlay._psSourceGallery||null;
        var closingIndex=overlay._psIndex||0;
        overlay.classList.remove('is-open');
        overlay.classList.remove('is-zoomed');
        document.documentElement.classList.remove('ps-lightbox-open');
        document.body.classList.remove('ps-lightbox-open');
        overlay._psGroup=[];
        overlay._psIndex=0;
        overlay._psSourceGallery=null;
        if(sourceGallery && typeof sourceGallery._psGoTo==='function'){
          requestAnimationFrame(function(){
            sourceGallery._psGoTo(closingIndex,'auto',true);
          });
        }
      }
      function showGroupIndex(nextIndex){
        var group=overlay._psGroup||[];
        if(group.length<2 || overlay.classList.contains('is-zoomed')) return;
        nextIndex=(nextIndex+group.length)%group.length;
        if(nextIndex===overlay._psIndex) return;
        overlay._psIndex=nextIndex;
        image.classList.add('is-swapping');
        setTimeout(function(){
          image.src=group[nextIndex];
          image.onload=function(){
            image.classList.remove('is-swapping');
            positionControls();
            image.onload=positionControls;
          };
        },80);
      }
      overlay._psShowGroupIndex=showGroupIndex;
      if(prevButton) prevButton.addEventListener('click',function(e){ e.stopPropagation(); showGroupIndex(overlay._psIndex-1); });
      if(nextButton) nextButton.addEventListener('click',function(e){ e.stopPropagation(); showGroupIndex(overlay._psIndex+1); });

      overlay.addEventListener('click',function(e){
        var clickedBackdrop=(e.target===overlay || e.target===viewport);
        if(clickedBackdrop || e.target.closest('.ps-lightbox__close')) closeLightbox();
      });
      document.addEventListener('keydown',function(e){
        if(!overlay.classList.contains('is-open')) return;
        if(e.key==='Escape') closeLightbox();
        if(e.key==='ArrowLeft') showGroupIndex(overlay._psIndex-1);
        if(e.key==='ArrowRight') showGroupIndex(overlay._psIndex+1);
      });
      if(zoomButton) zoomButton.addEventListener('click',function(){ overlay.classList.toggle('is-zoomed'); setTimeout(positionControls,30); });
      if(image){
        image.addEventListener('dblclick',function(){ overlay.classList.toggle('is-zoomed'); setTimeout(positionControls,30); });
        image.addEventListener('load',positionControls);
      }

      var startX=0,startY=0,tracking=false;
      viewport.addEventListener('touchstart',function(e){
        if(e.touches.length!==1 || overlay.classList.contains('is-zoomed')) return;
        startX=e.touches[0].clientX; startY=e.touches[0].clientY; tracking=true;
      },{passive:true});
      viewport.addEventListener('touchmove',function(e){
        if(!tracking || e.touches.length!==1) return;
        var dx=e.touches[0].clientX-startX;
        var dy=e.touches[0].clientY-startY;
        if(Math.abs(dx)>Math.abs(dy)+8 && Math.abs(dx)>12) e.preventDefault();
      },{passive:false});
      viewport.addEventListener('touchend',function(e){
        if(!tracking) return;
        tracking=false;
        var touch=e.changedTouches&&e.changedTouches[0];
        if(!touch) return;
        var dx=touch.clientX-startX;
        var dy=touch.clientY-startY;
        if(Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.15){
          showGroupIndex(overlay._psIndex+(dx<0?1:-1));
        }
      },{passive:true});
      window.addEventListener('resize',positionControls,{passive:true});
      overlay._psPositionControls=positionControls;
    }

    function bind(sel){
      doc.querySelectorAll(sel).forEach(function(el){
        if(el.dataset.lightboxInit) return;
        el.dataset.lightboxInit='1';
        el.style.cursor='zoom-in';
        el.addEventListener('click',function(){
          var src=el.getAttribute('data-lightbox-src') || el.getAttribute('src');
          var img=overlay.querySelector('.ps-lightbox__image');
          var isProduct=!!el.closest('.ps-pdp-media');
          if(isProduct){
            var gallery=el.closest('[data-pdp-gallery]') || document.querySelector('[data-pdp-gallery]');
            var imgs=gallery?Array.prototype.slice.call(gallery.querySelectorAll('.ps-pdp-media img')):[];
            overlay._psGroup=imgs.map(function(item){ return item.getAttribute('data-lightbox-src') || item.getAttribute('src'); });
            overlay._psIndex=Math.max(0,imgs.indexOf(el));
            overlay._psSourceGallery=gallery||null;
          }else{
            overlay._psGroup=[src];
            overlay._psIndex=0;
            overlay._psSourceGallery=null;
          }
          /* Do not expose the navigation controls until the enlarged image has real
             dimensions. On a cold iPhone load this prevents the arrows from briefly
             appearing in the middle of an empty viewer. */
          overlay.classList.add('ps-lightbox-loading');
          var readyDone=false;
          function finishLightboxOpen(){
            if(readyDone || !overlay.classList.contains('is-open')) return;
            readyDone=true;
            if(overlay._psPositionControls) overlay._psPositionControls();
            requestAnimationFrame(function(){
              if(!overlay.classList.contains('is-open')) return;
              if(overlay._psPositionControls) overlay._psPositionControls();
              overlay.classList.remove('ps-lightbox-loading');
              /* Restart the existing arrow introduction only after the image is visible. */
              overlay.classList.add('ps-nav-opening');
              clearTimeout(overlay._psReadyNavTimer);
              overlay._psReadyNavTimer=setTimeout(function(){ overlay.classList.remove('ps-nav-opening'); },1050);
            });
          }
          img.addEventListener('load',finishLightboxOpen,{once:true});
          img.src=src;
          overlay.classList.toggle('has-gallery',overlay._psGroup.length>1);
          overlay.classList.add('is-open');
          document.documentElement.classList.add('ps-lightbox-open');
          document.body.classList.add('ps-lightbox-open');
          if(img.complete && img.naturalWidth) requestAnimationFrame(finishLightboxOpen);
        });
      });
    }
    bind('.ps-photo-review-card__media');
    bind('.ps-review-row__photo');
    bind('.ps-pdp-media img');
    doc.querySelectorAll('[data-gallery-zoom]').forEach(function(button){
      if(button.dataset.zoomInit) return; button.dataset.zoomInit='1';
      button.addEventListener('click',function(){
        var gallery=button.closest('.ps-pdp__media-wrap')?.querySelector('[data-pdp-gallery]');
        if(!gallery) return;
        var items=Array.prototype.slice.call(gallery.querySelectorAll('.ps-pdp-media'));
        var idx=Math.round(gallery.scrollLeft/Math.max(1,gallery.clientWidth));
        var img=items[Math.max(0,Math.min(items.length-1,idx))]?.querySelector('img');
        if(img) img.click();
      });
    });
  }

  function initAutoHideHeader(){
    var mainHeader=document.querySelector('[data-ps-header]');
    var compact=document.querySelector('[data-ps-scroll-header]');
    if(!mainHeader || !compact || compact.dataset.scrollHeaderInit) return;
    compact.dataset.scrollHeaderInit='1';

    var lastY=Math.max(0,window.scrollY);
    var lastTouchY=null;
    var ticking=false;

    function showCompact(){
      if(window.scrollY<120) return hideCompact();
      compact.classList.add('is-visible');
      compact.setAttribute('aria-hidden','false');
      updateFloatingCartVisibility();
    }
    function hideCompact(){
      compact.classList.remove('is-visible');
      compact.setAttribute('aria-hidden','true');
      updateFloatingCartVisibility();
    }
    function update(){
      ticking=false;
      var y=Math.max(0,window.scrollY);
      var delta=y-lastY;
      if(document.documentElement.classList.contains('ps-lightbox-open')){
        hideCompact();
      }else if(y<120){
        hideCompact();
      }else if(delta<-1){
        showCompact();
      }else if(delta>2){
        hideCompact();
      }
      lastY=y;
    }

    window.addEventListener('scroll',function(){
      if(!ticking){ ticking=true; requestAnimationFrame(update); }
    },{passive:true});
    window.addEventListener('touchstart',function(e){
      if(e.touches&&e.touches[0]) lastTouchY=e.touches[0].clientY;
    },{passive:true});
    window.addEventListener('touchmove',function(e){
      if(!e.touches||!e.touches[0]||lastTouchY===null) return;
      var current=e.touches[0].clientY;
      var fingerDelta=current-lastTouchY;
      if(window.scrollY>120){
        if(fingerDelta>2) showCompact();
        else if(fingerDelta<-4) hideCompact();
      }
      lastTouchY=current;
    },{passive:true});
    window.addEventListener('touchend',function(){ lastTouchY=null; },{passive:true});
    window.addEventListener('wheel',function(e){
      if(window.scrollY<=120) return hideCompact();
      if(e.deltaY<0) showCompact();
      else if(e.deltaY>0) hideCompact();
    },{passive:true});
    window.addEventListener('resize',function(){
      lastY=Math.max(0,window.scrollY);
      if(lastY<120) hideCompact();
    },{passive:true});
    hideCompact();
  }

  function initHeroPerformance(){
    var hero=document.querySelector('.template-index .ps-hero--saber');
    if(!hero || hero.dataset.heroPerfInit) return;
    hero.dataset.heroPerfInit='1';
    if(!('IntersectionObserver' in window)) return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        hero.classList.toggle('is-offscreen',!entry.isIntersecting);
      });
    },{rootMargin:'100px 0px 100px',threshold:0});
    io.observe(hero);
  }

  function initStickyBuy(){
    var bar=document.querySelector('[data-sticky-buy]');
    if(!bar || bar.dataset.stickyInit) return;
    bar.dataset.stickyInit='1';
    var primary=document.querySelector('.ps-pdp__add');
    function update(){
      if(!primary){
        bar.classList.toggle('is-visible',window.scrollY>520);
        updateFloatingCartVisibility();
        return;
      }
      var rect=primary.getBoundingClientRect();
      var shouldShow=false;
      if(window.innerWidth<=640){
        var barHeight=bar.offsetHeight || 86;
        var revealLine=window.innerHeight - barHeight - 230;
        shouldShow=rect.bottom < revealLine;
      }else{
        var header=document.querySelector('[data-ps-header]');
        var headerBottom=header ? header.getBoundingClientRect().bottom : 84;
        shouldShow=rect.bottom < headerBottom + 18;
      }
      bar.classList.toggle('is-visible',shouldShow);
      var glassX=38 + ((window.scrollY % 240) / 240) * 32;
      bar.style.setProperty('--ps-glass-x',glassX.toFixed(1)+'%');
      updateFloatingCartVisibility();
    }
    update();
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
  }

  function initHomeStickyBuy(){
    var bar=document.querySelector('[data-home-sticky-buy]');
    if(!bar || bar.dataset.homeStickyInit) return;
    bar.dataset.homeStickyInit='1';
    var actions=document.querySelector('.ps-hero__actions');
    function update(){
      if(window.innerWidth>640){ bar.classList.remove('is-visible'); return; }
      if(!actions){ bar.classList.toggle('is-visible',window.scrollY>420); return; }
      var rect=actions.getBoundingClientRect();
      var header=document.querySelector('[data-ps-header]');
      var headerBottom=header && !header.classList.contains('is-scroll-hidden') ? header.getBoundingClientRect().bottom : 0;
      /* Bring the quick CTA in slightly before the original button fully disappears. */
      var shouldShow=window.scrollY>35 && rect.bottom < Math.max(96,headerBottom+108);
      bar.classList.toggle('is-visible',shouldShow);
      updateFloatingCartVisibility();
    }
    update();
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
  }

  function initFaqLinks(root){
    var doc=root||document;
    doc.querySelectorAll('a[href*="#faq"]').forEach(function(link){
      if(link.dataset.faqInit) return;
      link.dataset.faqInit='1';
      link.addEventListener('click',function(e){
        var href=link.getAttribute('href')||'';
        var hashIndex=href.indexOf('#faq');
        if(hashIndex<0) return;
        var targetUrl=href.slice(0,hashIndex);
        var currentPath=window.location.pathname.replace(/\/$/,'');
        var a=document.createElement('a');
        a.href=targetUrl||window.location.href;
        var targetPath=a.pathname.replace(/\/$/,'');
        if(!targetUrl || targetPath===currentPath){
          var faq=document.getElementById('faq');
          if(faq){
            e.preventDefault();
            history.replaceState(null,'','#faq');
            var header=document.querySelector('[data-ps-header]');
            var offset=(header?header.getBoundingClientRect().height:90)+10;
            var top=Math.max(0,faq.getBoundingClientRect().top+window.scrollY-offset);
            window.scrollTo({top:top,behavior:'smooth'});
          }
        }
      });
    });
  }

  function forceHashTarget(){
    if(window.location.hash!=='#faq') return;
    var faq=document.getElementById('faq');
    if(!faq) return;
    var header=document.querySelector('[data-ps-header]');
    var offset=(header?header.getBoundingClientRect().height:90)+10;
    var top=Math.max(0,faq.getBoundingClientRect().top+window.scrollY-offset);
    window.scrollTo({top:top,behavior:'auto'});
  }

  function initGalleryPrewarm(){
    if(!document.body.classList.contains('template-product') || document.documentElement.dataset.galleryPrewarmInit) return;
    document.documentElement.dataset.galleryPrewarmInit='1';
    function warm(){
      var urls=Array.prototype.slice.call(document.querySelectorAll('[data-pdp-gallery] img[data-lightbox-src]')).map(function(img){ return img.getAttribute('data-lightbox-src'); }).filter(Boolean);
      if(!urls.length) return;
      /* Start the tail image first because it used to be the easiest one to reach before its lazy request began. */
      var ordered=[urls[urls.length-1]].concat(urls.slice(1,-1));
      ordered.forEach(function(url,index){
        setTimeout(function(){
          var img=new Image();
          img.decoding='async';
          try{ img.fetchPriority='low'; }catch(e){}
          img.src=url;
        },index*70);
      });
    }
    /* theme.js is deferred, so this runs after parsing without waiting for window.load/idle.
       The first product image and pack art retain HIGH priority; this queue is intentionally LOW. */
    setTimeout(warm,120);
  }

  function initSectionTitleReveal(root){
    var doc=root||document;
    var targets=Array.prototype.slice.call(doc.querySelectorAll(
      '.template-product .ps-review-heading--videos,'+
      '.template-product .ps-reviews--pdp .ps-review-heading,'+
      '.template-product .ps-reviews--pdp .ps-rating-panel'
    ));
    targets.forEach(function(el){
      if(el.dataset.titleRevealInit) return;
      el.dataset.titleRevealInit='1';
      el.classList.add('ps-title-reveal');
      el.style.setProperty('--ps-title-delay','0ms');
    });
    if(!targets.length) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)){
      targets.forEach(function(el){el.classList.add('is-visible');});
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    },{threshold:.08,rootMargin:'0px 0px -8% 0px'});
    targets.forEach(function(el){io.observe(el);});
  }

  function initAll(root){
    initProductForms(root);
    initCartPage(root);
    initSaleCountdown();
    initPdpGallery(root);
    initVideoCarousels(root);
    initReviewSections(root);
    initReveal(root);
    initAccordions(root);
    initLightbox(root);
    initAutoHideHeader();
    initHeroPerformance();
    initStickyBuy();
    initHomeStickyBuy();
    initFaqLinks(root);
    initGalleryPrewarm();
    initSectionTitleReveal(root);
    updateFloatingCartVisibility();
  }

  initAll(document);
  restoreSessionCartCount();
  window.addEventListener('pageshow',function(e){
    var nav=null;
    try{ nav=performance.getEntriesByType('navigation')[0]||null; }catch(err){}
    var isHistoryRestore=!!(e.persisted || (nav && nav.type==='back_forward'));
    if(isHistoryRestore){
      restoreSessionCartCount();
      syncCartCountFromServer();
    }
  });
  if(window.location.hash==='#faq'){
    setTimeout(forceHashTarget,80);
    setTimeout(forceHashTarget,450);
    window.addEventListener('load',function(){ setTimeout(forceHashTarget,80); },{once:true});
  }
  document.addEventListener('shopify:section:load',function(e){ initAll(e.target); });
})();

/* V9.41: support sheets preserve the exact page position while keeping the blurred page visible. */
(function(){
  var supportScrollY=0;
  function dialogFor(name){ return document.querySelector('[data-support-dialog="'+name+'"]'); }
  function preventBackgroundScroll(e){
    if(!document.body.classList.contains('ps-support-open')) return;
    var panel=e.target && e.target.closest ? e.target.closest('.ps-support-dialog__panel') : null;
    if(!panel) e.preventDefault();
  }
  function lockSupportScroll(){
    if(document.body.classList.contains('ps-support-open')) return;
    supportScrollY=Math.max(0,window.scrollY||window.pageYOffset||0);
    document.documentElement.classList.add('ps-support-open');
    document.body.classList.add('ps-support-open');
    document.addEventListener('touchmove',preventBackgroundScroll,{passive:false});
    document.addEventListener('wheel',preventBackgroundScroll,{passive:false});
  }
  function unlockSupportScroll(){
    if(!document.body.classList.contains('ps-support-open')) return;
    document.removeEventListener('touchmove',preventBackgroundScroll,{passive:false});
    document.removeEventListener('wheel',preventBackgroundScroll,{passive:false});
    document.documentElement.classList.remove('ps-support-open');
    document.body.classList.remove('ps-support-open');
    /* Overflow locking should preserve the position by itself. Restore only if Safari drifted. */
    var target=supportScrollY;
    if(Math.abs((window.scrollY||0)-target)>2){
      window.scrollTo(0,target);
      requestAnimationFrame(function(){ window.scrollTo(0,target); });
    }
  }
  function openSupport(name,topic){
    var dialog=dialogFor(name);
    if(!dialog) return;
    if(topic){
      var select=dialog.querySelector('[data-support-topic-select]');
      if(select){
        for(var i=0;i<select.options.length;i++){
          if(select.options[i].value===topic){ select.selectedIndex=i; break; }
        }
      }
    }
    if(typeof dialog.showModal==='function' && !dialog.open){
      lockSupportScroll();
      dialog.showModal();
    }
  }
  function closeSupport(dialog){
    if(dialog && dialog.open) dialog.close();
    unlockSupportScroll();
  }
  document.addEventListener('click',function(e){
    var opener=e.target.closest('[data-support-open]');
    if(opener){
      var name=opener.getAttribute('data-support-open');
      var topic=opener.getAttribute('data-support-topic')||'';
      var dialog=dialogFor(name);
      if(dialog && typeof dialog.showModal==='function'){
        e.preventDefault();
        openSupport(name,topic);
      }
      return;
    }
    var closer=e.target.closest('[data-support-close]');
    if(closer){ e.preventDefault(); closeSupport(closer.closest('dialog')); return; }
    var switcher=e.target.closest('[data-support-switch]');
    if(switcher){
      e.preventDefault();
      closeSupport(switcher.closest('dialog'));
      openSupport(switcher.getAttribute('data-support-switch'),switcher.getAttribute('data-support-topic')||'');
      return;
    }
    if(e.target && e.target.matches && e.target.matches('.ps-support-dialog')) closeSupport(e.target);
  });
  document.addEventListener('close',function(e){
    if(e.target && e.target.matches && e.target.matches('.ps-support-dialog')) unlockSupportScroll();
  },true);
  window.addEventListener('load',function(){
    var hash=window.location.hash;
    if(hash==='#contact-us' || document.querySelector('.ps-support-form__success,.ps-support-form .errors')) openSupport('contact','');
    if(hash==='#order-status') openSupport('order','');
  },{once:true});
})();


/* V9.41: lightweight lightbox polish — pinch/pan zoom and auto-fading gallery arrows. */
(function(){
  function install(){
    var overlay=document.getElementById('psLightbox');
    if(!overlay || overlay.dataset.psV941) return !!overlay;
    overlay.dataset.psV941='1';
    var viewport=overlay.querySelector('.ps-lightbox__viewport');
    var image=overlay.querySelector('.ps-lightbox__image');
    var zoomButton=overlay.querySelector('.ps-lightbox__zoom');
    var navButtons=overlay.querySelectorAll('.ps-lightbox__nav');
    if(!viewport || !image) return true;

    var controlsTimer=0;
    function showControls(){
      if(!overlay.classList.contains('is-open')) return;
      overlay.classList.add('ps-controls-active');
      clearTimeout(controlsTimer);
      controlsTimer=setTimeout(function(){ overlay.classList.remove('ps-controls-active'); },1100);
    }
    navButtons.forEach(function(btn){
      btn.addEventListener('click',showControls);
      btn.addEventListener('pointerdown',showControls,{passive:true});
    });
    overlay.addEventListener('pointerdown',showControls,{passive:true});

    var scale=1,tx=0,ty=0;
    var pinchStartDist=0,pinchStartScale=1,pinchCenterX=0,pinchCenterY=0,pinchStartTx=0,pinchStartTy=0;
    var panStartX=0,panStartY=0,panStartTx=0,panStartTy=0,panning=false,pinching=false;

    function distance(a,b){ var dx=a.clientX-b.clientX,dy=a.clientY-b.clientY; return Math.hypot(dx,dy); }
    function midpoint(a,b){ return {x:(a.clientX+b.clientX)/2,y:(a.clientY+b.clientY)/2}; }
    function clamp(v,min,max){ return Math.max(min,Math.min(max,v)); }
    function clampPan(){
      var vw=viewport.clientWidth||window.innerWidth;
      var vh=viewport.clientHeight||window.innerHeight;
      var iw=image.offsetWidth||image.getBoundingClientRect().width/Math.max(scale,.01);
      var ih=image.offsetHeight||image.getBoundingClientRect().height/Math.max(scale,.01);
      var maxX=Math.max(0,(iw*scale-vw)/2+28);
      var maxY=Math.max(0,(ih*scale-vh)/2+28);
      tx=clamp(tx,-maxX,maxX); ty=clamp(ty,-maxY,maxY);
    }
    function renderZoom(){
      clampPan();
      image.style.setProperty('--ps-pinch-scale',scale.toFixed(4));
      image.style.setProperty('--ps-pinch-x',tx.toFixed(1)+'px');
      image.style.setProperty('--ps-pinch-y',ty.toFixed(1)+'px');
      if(scale>1.01){
        overlay.classList.add('is-zoomed','ps-pinch-zoomed');
      }else{
        scale=1;tx=0;ty=0;
        overlay.classList.remove('ps-pinch-zoomed','is-zoomed');
      }
    }
    function resetZoom(){
      scale=1;tx=0;ty=0;panning=false;pinching=false;
      image.style.removeProperty('--ps-pinch-scale');
      image.style.removeProperty('--ps-pinch-x');
      image.style.removeProperty('--ps-pinch-y');
      overlay.classList.remove('ps-pinch-zoomed');
    }
    function adoptButtonZoom(){
      setTimeout(function(){
        if(!overlay.classList.contains('is-open')) return;
        if(overlay.classList.contains('is-zoomed')){
          if(scale<=1.01){ scale=1.35;tx=0;ty=0;overlay.classList.add('ps-pinch-zoomed');renderZoom(); }
        }else resetZoom();
      },0);
    }
    if(zoomButton) zoomButton.addEventListener('click',adoptButtonZoom);
    image.addEventListener('dblclick',adoptButtonZoom);

    viewport.addEventListener('touchstart',function(e){
      if(!overlay.classList.contains('is-open')) return;
      showControls();
      if(e.touches.length===2){
        if(overlay.classList.contains('is-zoomed') && scale<=1.01) scale=1.35;
        pinching=true;panning=false;
        pinchStartDist=Math.max(1,distance(e.touches[0],e.touches[1]));
        pinchStartScale=scale;
        pinchStartTx=tx;pinchStartTy=ty;
        var mid=midpoint(e.touches[0],e.touches[1]);
        var vr=viewport.getBoundingClientRect();
        pinchCenterX=mid.x-(vr.left+vr.width/2);
        pinchCenterY=mid.y-(vr.top+vr.height/2);
        overlay.classList.add('is-zoomed','ps-pinch-zoomed');
      }else if(e.touches.length===1 && scale>1.01){
        panning=true;pinching=false;
        panStartX=e.touches[0].clientX;panStartY=e.touches[0].clientY;
        panStartTx=tx;panStartTy=ty;
      }
    },{passive:true});
    viewport.addEventListener('touchmove',function(e){
      if(pinching && e.touches.length===2){
        e.preventDefault();
        var next=clamp(pinchStartScale*(distance(e.touches[0],e.touches[1])/pinchStartDist),1,4);
        var ratio=next/Math.max(.01,pinchStartScale);
        scale=next;
        tx=pinchCenterX-(pinchCenterX-pinchStartTx)*ratio;
        ty=pinchCenterY-(pinchCenterY-pinchStartTy)*ratio;
        renderZoom();
      }else if(panning && e.touches.length===1 && scale>1.01){
        e.preventDefault();
        tx=panStartTx+(e.touches[0].clientX-panStartX);
        ty=panStartTy+(e.touches[0].clientY-panStartY);
        renderZoom();
      }
    },{passive:false});
    viewport.addEventListener('touchend',function(e){
      if(e.touches.length<2) pinching=false;
      if(e.touches.length===0) panning=false;
      if(scale<1.03){ scale=1;tx=0;ty=0;renderZoom(); }
    },{passive:true});

    image.addEventListener('load',function(){ if(scale>1.01){tx=0;ty=0;renderZoom();} });
    var wasOpen=overlay.classList.contains('is-open');
    if(wasOpen) showControls();
    var observer=new MutationObserver(function(){
      var isOpen=overlay.classList.contains('is-open');
      if(isOpen && !wasOpen) showControls();
      if(!isOpen && wasOpen){ clearTimeout(controlsTimer);overlay.classList.remove('ps-controls-active');resetZoom(); }
      wasOpen=isOpen;
    });
    observer.observe(overlay,{attributes:true,attributeFilter:['class']});
    return true;
  }
  function boot(){
    if(install()) return;
    var mo=new MutationObserver(function(){ if(install()) mo.disconnect(); });
    mo.observe(document.documentElement,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();

/* V9.42: release touch focus from lightbox arrows so the last tapped control can fade normally. */
(function(){
  function installV942LightboxFade(){
    var overlay=document.getElementById('psLightbox');
    if(!overlay || overlay.dataset.psV942) return !!overlay;
    overlay.dataset.psV942='1';
    overlay.querySelectorAll('.ps-lightbox__nav').forEach(function(btn){
      btn.addEventListener('pointerup',function(){
        if(window.matchMedia && window.matchMedia('(hover: none)').matches){
          window.setTimeout(function(){ try{ btn.blur(); }catch(e){} },0);
        }
      },{passive:true});
      btn.addEventListener('touchend',function(){
        window.setTimeout(function(){ try{ btn.blur(); }catch(e){} },0);
      },{passive:true});
    });
    return true;
  }
  function bootV942(){
    if(installV942LightboxFade()) return;
    var mo=new MutationObserver(function(){ if(installV942LightboxFade()) mo.disconnect(); });
    mo.observe(document.documentElement,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bootV942,{once:true});
  else bootV942();
})();

/* V9.43: lightbox arrows fade independently after the opening introduction. */
(function(){
  function installV943LightboxArrows(){
    var overlay=document.getElementById('psLightbox');
    if(!overlay || overlay.dataset.psV943) return !!overlay;
    overlay.dataset.psV943='1';
    var buttons=Array.prototype.slice.call(overlay.querySelectorAll('.ps-lightbox__nav'));
    if(!buttons.length) return true;

    var openingTimer=0;
    var buttonTimers=new WeakMap();
    function clearButtonState(btn){
      var timer=buttonTimers.get(btn);
      if(timer) clearTimeout(timer);
      btn.classList.remove('ps-nav-active');
    }
    function introduceArrows(){
      clearTimeout(openingTimer);
      buttons.forEach(clearButtonState);
      overlay.classList.add('ps-nav-opening');
      openingTimer=setTimeout(function(){
        overlay.classList.remove('ps-nav-opening');
      },1050);
    }
    function emphasize(btn){
      overlay.classList.remove('ps-nav-opening');
      clearTimeout(openingTimer);
      clearButtonState(btn);
      btn.classList.add('ps-nav-active');
      var timer=setTimeout(function(){
        btn.classList.remove('ps-nav-active');
        try{ btn.blur(); }catch(e){}
      },900);
      buttonTimers.set(btn,timer);
    }

    buttons.forEach(function(btn){
      btn.addEventListener('pointerdown',function(){ emphasize(btn); },{passive:true});
      btn.addEventListener('touchstart',function(){ emphasize(btn); },{passive:true});
    });

    var wasOpen=overlay.classList.contains('is-open');
    if(wasOpen) introduceArrows();
    var observer=new MutationObserver(function(){
      var isOpen=overlay.classList.contains('is-open');
      if(isOpen && !wasOpen) introduceArrows();
      if(!isOpen && wasOpen){
        clearTimeout(openingTimer);
        overlay.classList.remove('ps-nav-opening');
        buttons.forEach(clearButtonState);
      }
      wasOpen=isOpen;
    });
    observer.observe(overlay,{attributes:true,attributeFilter:['class']});
    return true;
  }
  function bootV943(){
    if(installV943LightboxArrows()) return;
    var mo=new MutationObserver(function(){ if(installV943LightboxArrows()) mo.disconnect(); });
    mo.observe(document.documentElement,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bootV943,{once:true});
  else bootV943();
})();


/* V9.50 SAFE: preview-arrow visibility only. Intentionally does not touch #psLightbox. */
(function(){
  function initPreviewArrowFade(){
    document.querySelectorAll('.ps-pdp__media-wrap').forEach(function(wrap){
      if(wrap.dataset.psPreviewFadeInit) return;
      var buttons=Array.prototype.slice.call(wrap.querySelectorAll('.ps-gallery-arrow'));
      if(!buttons.length) return;
      wrap.dataset.psPreviewFadeInit='1';
      var introTimer=0;
      var timers=new WeakMap();

      function clearButton(btn){
        var t=timers.get(btn); if(t) clearTimeout(t);
        btn.classList.remove('ps-preview-arrow-active');
      }
      function introduce(){
        clearTimeout(introTimer);
        buttons.forEach(clearButton);
        wrap.classList.add('ps-preview-arrows-opening');
        introTimer=setTimeout(function(){ wrap.classList.remove('ps-preview-arrows-opening'); },1050);
      }
      function pulse(btn){
        clearTimeout(introTimer);
        wrap.classList.remove('ps-preview-arrows-opening');
        clearButton(btn);
        btn.classList.add('ps-preview-arrow-active');
        var t=setTimeout(function(){
          btn.classList.remove('ps-preview-arrow-active');
          try{ btn.blur(); }catch(e){}
        },900);
        timers.set(btn,t);
      }
      buttons.forEach(function(btn){
        btn.addEventListener('pointerdown',function(){ pulse(btn); },{passive:true});
      });
      introduce();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initPreviewArrowFade,{once:true});
  else initPreviewArrowFade();
})();
